// =====================================================================
// NIX SELL — tema Shopify
// Carrello collegato a Shopify (AJAX Cart API), pagina prodotto a schermo intero,
// carosello recensioni, notifiche ordini e promemoria carrello.
// =====================================================================
(function () {
  const cfg = window.NixSell || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // ===== PREZZI =====
  // Usa il formato valuta del negozio (Impostazioni > Generali > Valuta del negozio)
  function formatMoney(cents) {
    const format = cfg.moneyFormat || '€{{amount_with_comma_separator}}';
    const value = (cents || 0) / 100;
    const withSep = (n, dec, thousands, decimal) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return withSep(value, 2, ',', '.');
        case 'amount_no_decimals': return withSep(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withSep(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSep(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withSep(value, 2, "'", '.');
        default: return withSep(value, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  const escapeHtml = (s) => String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  // ===== TOAST =====
  let toastTimer;
  function showToast(text) {
    const t = $('#toast');
    if (!t) return;
    $('#toastText').textContent = text;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 2500);
  }

  // ===== CARRELLO (Shopify) =====
  let cart = cfg.cart || { items: [], item_count: 0, total_price: 0 };

  async function fetchCart() {
    const res = await fetch(cfg.routes.cartJs, { headers: { Accept: 'application/json' } });
    cart = await res.json();
    renderCart();
    return cart;
  }

  async function addToCart(variantId, title, button, quiet) {
    if (!variantId) return false;
    if (button) button.classList.add('loading');
    try {
      const res = await fetch(cfg.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      const data = await res.json();
      if (!res.ok) { showToast(data.description || 'Impossibile aggiungere il prodotto'); return false; }
      await fetchCart();
      if (!quiet) {
        showToast(`${title || 'Prodotto'} aggiunto al carrello`);
        cartMarketing.onAdd();
      }
      return true;
    } catch {
      showToast('Errore di connessione, riprova');
      return false;
    } finally {
      if (button) button.classList.remove('loading');
    }
  }

  async function changeLine(key, quantity) {
    const res = await fetch(cfg.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    });
    cart = await res.json();
    renderCart();
  }

  function cartImage(item) {
    if (item.image) {
      const url = item.image + (item.image.includes('?') ? '&' : '?') + 'width=160';
      return `<img class="cart-item-img" src="${escapeHtml(url)}" alt="${escapeHtml(item.product_title)}" width="48" height="48">`;
    }
    const tpl = document.getElementById(`pp-tpl-${item.handle}`);
    const fallback = tpl && tpl.content.querySelector('[data-pp-main]');
    if (fallback) return `<img class="cart-item-img" src="${escapeHtml(fallback.getAttribute('src'))}" alt="${escapeHtml(item.product_title)}" width="48" height="48">`;
    return `<div class="cart-item-icon"><i class="fa-solid fa-box"></i></div>`;
  }

  function renderCart() {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    const total = $('#cartTotal');
    if (total) total.textContent = formatMoney(cart.total_price);
    const list = $('#cartItems');
    if (!list) return;

    if (!cart.items.length) {
      list.innerHTML = `<div class="cart-empty"><i class="fa-solid fa-cart-arrow-down"></i>Il carrello è vuoto</div>`;
      return;
    }
    list.innerHTML = cart.items.map((item) => `
      <div class="cart-item">
        ${cartImage(item)}
        <div class="cart-item-info">
          <h4>${escapeHtml(item.product_title)}</h4>
          <span>${formatMoney(item.final_line_price)}</span>
          <div class="qty">
            <button type="button" data-dec="${item.key}" data-qty="${item.quantity}" aria-label="Meno"><i class="fa-solid fa-minus"></i></button>
            <strong>${item.quantity}</strong>
            <button type="button" data-inc="${item.key}" data-qty="${item.quantity}" aria-label="Più"><i class="fa-solid fa-plus"></i></button>
          </div>
        </div>
        <button class="remove" type="button" data-remove="${item.key}" aria-label="Rimuovi"><i class="fa-solid fa-trash"></i></button>
      </div>`).join('');
  }

  function openCart() {
    $('#cart').classList.add('open');
    $('#overlay').classList.add('show');
    cartMarketing.onCartOpen();
  }
  function closeCart() {
    if (!$('#cart').classList.contains('open')) return;
    $('#cart').classList.remove('open');
    $('#overlay').classList.remove('show');
    cartMarketing.onCartClose();
  }

  // ===== CHECKOUT DIRETTO SHOPIFY =====
  // "Acquista ora" e "Procedi al checkout" portano subito al pagamento di Shopify.
  // Il consenso (termini + consegna immediata con rinuncia al recesso) è scritto sotto i pulsanti
  // e viene salvato sull'ordine come attributo, con data e ora del clic.
  async function goToCheckout(button, source) {
    if (!cart.items.length) { showToast('Il carrello è vuoto'); return; }
    if (button) button.classList.add('loading');
    const when = new Date().toLocaleString('it-IT');
    try {
      await fetch(cfg.routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: {
          'Consenso termini e privacy': `Sì, clic su "${source}" (${when})`,
          'Consenso consegna immediata e rinuncia recesso': `Sì, clic su "${source}" (${when})`
        } })
      });
    } catch {}
    cartMarketing.onPurchase();
    window.location.href = '/checkout';
  }

  // Pagina /cart: salva il consenso sull'ordine prima del checkout
  function initCartPage() {
    const form = $('#cartPageForm');
    if (!form) return;
    form.addEventListener('submit', () => {
      const when = new Date().toLocaleString('it-IT');
      $$('input[type=hidden][name^="attributes"]', form).forEach((h) => { h.value = `Sì, clic su "Vai al pagamento" (${when})`; });
    });
  }

  // ===== PAGINA PRODOTTO A SCHERMO INTERO (home) =====
  // Si apre cliccando una card. L'indirizzo diventa #p/handle, così il tasto "indietro"
  // la chiude e il link si può condividere. Senza la pagina (es. collezioni) la card apre /products/handle.
  const pp = () => document.getElementById('productPage');
  let productOpenedHere = false;

  function renderProductPage(handle) {
    const tpl = document.getElementById(`pp-tpl-${handle}`);
    if (!tpl) return false;
    $('#ppContent').innerHTML = '';
    $('#ppContent').appendChild(tpl.content.cloneNode(true));
    $('#ppBarName').textContent = tpl.dataset.title;
    $('#ppBarPrice').textContent = tpl.dataset.price;
    const barAdd = $('#ppBarAdd');
    barAdd.dataset.add = tpl.dataset.variant;
    barAdd.dataset.title = tpl.dataset.title;
    barAdd.disabled = tpl.dataset.available !== 'true';
    return true;
  }

  function openProduct(handle, fromHash) {
    if (!pp() || !document.getElementById(`pp-tpl-${handle}`)) return false;
    // Da un prodotto all'altro ("Scopri anche"): sostituisce l'indirizzo
    if (!fromHash && pp().classList.contains('open')) {
      history.replaceState(null, '', `#p/${handle}`);
      renderProductPage(handle);
      pp().scrollTop = 0;
      return true;
    }
    if (!fromHash) {
      productOpenedHere = true;
      if (location.hash !== `#p/${handle}`) { location.hash = `p/${handle}`; return true; }
    }
    renderProductPage(handle);
    pp().classList.add('open');
    pp().scrollTop = 0;
    document.body.style.overflow = 'hidden';
    return true;
  }

  function closeProduct() {
    if (productOpenedHere) { productOpenedHere = false; history.back(); }
    else location.hash = 'prodotti';
  }

  function hideProductPage() {
    if (!pp()) return;
    pp().classList.remove('open');
    document.body.style.overflow = '';
  }

  function syncProductWithHash() {
    const m = location.hash.match(/^#p\/(.+)$/);
    if (m) openProduct(decodeURIComponent(m[1]), true);
    else hideProductPage();
  }

  // ===== CLIC =====
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-add],[data-buy],[data-inc],[data-dec],[data-remove],[data-open-cart],[data-photo]');
    if (t) {
      if (t.hasAttribute('data-open-cart')) { openCart(); return; }
      if (t.dataset.photo) {
        const main = t.closest('.pp-gallery').querySelector('[data-pp-main]');
        if (main) main.src = t.dataset.photo;
        $$('.pp-thumb', t.closest('.pp-thumbs')).forEach((b) => b.classList.toggle('active', b === t));
        return;
      }
      if (t.dataset.add !== undefined && t.dataset.add !== '') { addToCart(t.dataset.add, t.dataset.title, t); return; }
      if (t.dataset.buy) {
        addToCart(t.dataset.buy, t.dataset.title, t, true).then((ok) => { if (ok) goToCheckout(t, 'Acquista ora'); });
        return;
      }
      if (t.dataset.inc) { changeLine(t.dataset.inc, +t.dataset.qty + 1); return; }
      if (t.dataset.dec) { changeLine(t.dataset.dec, +t.dataset.qty - 1); return; }
      if (t.dataset.remove) { changeLine(t.dataset.remove, 0); return; }
      return;
    }

    // Card o "Scopri anche": pagina a schermo intero se c'è, altrimenti pagina prodotto
    const card = e.target.closest('[data-product]');
    if (card) {
      if (openProduct(card.dataset.product)) { e.preventDefault(); return; }
      if (card.dataset.url && card.tagName !== 'A') window.location.href = card.dataset.url;
    }
  });

  // Tastiera: Invio/Spazio sulla card la apre, Esc chiude
  document.addEventListener('keydown', (e) => {
    const card = e.target.closest && e.target.closest('.card[data-product]');
    if (card && (e.key === 'Enter' || e.key === ' ') && !e.target.closest('[data-add]')) {
      e.preventDefault();
      if (!openProduct(card.dataset.product) && card.dataset.url) window.location.href = card.dataset.url;
    }
    if (e.key === 'Escape') {
      if ($('#cart').classList.contains('open')) closeCart();
      else if (pp() && pp().classList.contains('open')) closeProduct();
    }
  });

  // ===== MENU, NAVBAR, FAQ =====
  function initNav() {
    const menuBtn = $('#menuBtn');
    const links = $('#navLinks');
    if (menuBtn && links) {
      menuBtn.addEventListener('click', () => links.classList.toggle('open'));
      $$('a', links).forEach((a) => a.addEventListener('click', () => links.classList.remove('open')));
    }
    const navbar = $('#navbar');
    const onScroll = () => navbar && navbar.classList.toggle('scrolled', window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initFaq(root = document) {
    $$('.faq-q', root).forEach((q) => {
      if (q.dataset.ready) return;
      q.dataset.ready = '1';
      q.addEventListener('click', () => {
        const item = q.parentElement;
        const answer = $('.faq-a', item);
        const isOpen = item.classList.toggle('open');
        answer.style.maxHeight = isOpen ? answer.scrollHeight + 'px' : 0;
      });
    });
  }

  // ===== PAROLA CHE CAMBIA NEL TITOLO =====
  const rotateTimers = new Map();
  function initRotate(root = document) {
    $$('[data-rotate-words]', root).forEach((el) => {
      clearInterval(rotateTimers.get(el));
      const words = el.dataset.rotateWords.split(',').map((w) => w.trim()).filter(Boolean);
      if (words.length < 2) return;
      let i = 0;
      rotateTimers.set(el, setInterval(() => {
        el.classList.add('out');
        setTimeout(() => {
          i = (i + 1) % words.length;
          el.textContent = words[i];
          el.classList.remove('out');
          el.classList.add('in');
          void el.offsetWidth; // forza il reflow per far ripartire la transizione
          el.classList.remove('in');
        }, 350);
      }, +el.dataset.rotateEvery || 2000));
    });
  }

  // ===== CAROSELLO RECENSIONI =====
  function initCarousel(root = document) {
    $$('[data-carousel]', root).forEach((car) => {
      if (car.dataset.ready) return;
      car.dataset.ready = '1';
      const track = $('[data-carousel-track]', car);
      const dots = $('[data-carousel-dots]', car);
      const viewport = $('[data-carousel-viewport]', car);
      const count = () => $$('.slide', track).length;
      const perView = () => parseInt(getComputedStyle(car).getPropertyValue('--per-view'), 10) || 1;
      let page = 0;

      function update() {
        const pv = perView();
        const n = count();
        const pages = Math.max(1, Math.ceil(n / pv));
        page = Math.min(page, pages - 1);
        const first = Math.max(0, Math.min(page * pv, n - pv));
        track.style.transform = `translateX(-${first * (100 / pv)}%)`;
        dots.innerHTML = pages > 1 ? Array.from({ length: pages }, (_, i) =>
          `<button type="button" class="${i === page ? 'active' : ''}" data-page="${i}" aria-label="Pagina ${i + 1}"></button>`
        ).join('') : '';
      }

      dots.addEventListener('click', (e) => {
        const b = e.target.closest('[data-page]');
        if (!b) return;
        page = +b.dataset.page;
        update();
      });

      let touchX = null;
      viewport.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; }, { passive: true });
      viewport.addEventListener('touchend', (e) => {
        if (touchX === null) return;
        const dx = e.changedTouches[0].clientX - touchX;
        const pages = Math.ceil(count() / perView());
        if (Math.abs(dx) > 50) {
          page = Math.max(0, Math.min(pages - 1, page + (dx < 0 ? 1 : -1)));
          update();
        }
        touchX = null;
      });

      window.addEventListener('resize', update);
      update();
    });
  }

  // ===== ANIMAZIONE COMPARSA =====
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('visible'); observer.unobserve(en.target); } });
    }, { threshold: 0.15 })
    : null;
  function initReveal(root = document) {
    $$('.reveal, .feature', root).forEach((el) => {
      el.classList.add('reveal');
      if (observer) observer.observe(el); else el.classList.add('visible');
    });
  }

  // ===== NOTIFICHE E PROMEMORIA =====
  let popupsCfg = { orders: { enabled: false, list: [] }, nudges: { enabled: false } };
  try { popupsCfg = JSON.parse($('#nixPopupsConfig').textContent); } catch {}

  function screenBusy() {
    return $('#cart').classList.contains('open') ||
      (pp() && pp().classList.contains('open')) || $('#cartNudge').classList.contains('show');
  }

  // Notifica "X ha ordinato ..." (solo ordini reali, vedi Personalizza > Notifiche e promemoria)
  const orderPop = (() => {
    const o = popupsCfg.orders;
    let index = 0, timer = null, started = false, stopped = false;

    function show() {
      if (!o.enabled || !o.list.length || stopped || index >= o.max) return;
      if (screenBusy()) { timer = setTimeout(show, 20000); return; }
      const item = o.list[index % o.list.length];
      index++;
      $('#orderPopText').innerHTML =
        `<strong>${escapeHtml(item.name)}</strong> ha ordinato <strong>${escapeHtml(item.pack)}</strong> ${escapeHtml(item.place)} ` +
        `<i class="fa-solid fa-location-dot pop-flag"></i>`;
      $('#orderPop').classList.add('show');
      timer = setTimeout(hide, o.visible);
    }
    function hide() {
      $('#orderPop').classList.remove('show');
      clearTimeout(timer);
      timer = setTimeout(show, o.gapMin + Math.random() * Math.max(0, o.gapMax - o.gapMin));
    }
    $('#orderPopClose').addEventListener('click', () => {
      stopped = true;
      clearTimeout(timer);
      $('#orderPop').classList.remove('show');
    });
    return {
      start() { if (started) return; started = true; timer = setTimeout(show, o.first); },
      hideNow() { $('#orderPop').classList.remove('show'); }
    };
  })();

  // Promemoria carrello abbandonato
  // 1. aggiunge un pack ma non apre il carrello   2. chiude il carrello senza ordinare
  // 3. il mouse esce dalla pagina (PC)            4. torna sul sito con il carrello pieno
  const cartMarketing = (() => {
    const n = popupsCfg.nudges;
    let timer = null, purchased = false;
    const shown = (() => { try { return JSON.parse(sessionStorage.getItem('nixsell-nudges')) || []; } catch { return []; } })();
    const saveShown = () => { try { sessionStorage.setItem('nixsell-nudges', JSON.stringify(shown)); } catch {} };

    const itemsText = () => cart.items.map((i) => i.quantity > 1 ? `${i.product_title} x${i.quantity}` : i.product_title).join(', ');
    const messages = {
      notOpened: () => ({ icon: 'fa-solid fa-cart-shopping', title: 'Il tuo pack ti aspetta',
        text: `Hai aggiunto <strong>${escapeHtml(itemsText())}</strong> al carrello. Completa l'ordine: la consegna è immediata.` }),
      abandoned: () => ({ icon: 'fa-solid fa-hourglass-half', title: 'Hai dimenticato qualcosa?',
        text: `Nel carrello hai ancora <strong>${escapeHtml(itemsText())}</strong> (${formatMoney(cart.total_price)}). Bastano 30 secondi per completare l'ordine.` }),
      exit: () => ({ icon: 'fa-solid fa-hand', title: 'Aspetta, non andare!',
        text: `Il tuo carrello da <strong>${formatMoney(cart.total_price)}</strong> è ancora qui. Completa ora e ricevi subito il tuo pack.` }),
      returning: () => ({ icon: 'fa-solid fa-face-smile', title: 'Bentornato!',
        text: `Hai ancora <strong>${escapeHtml(itemsText())}</strong> nel carrello. Riprendi da dove avevi lasciato.` })
    };

    function show(type) {
      if (!n.enabled || purchased || !cart.items.length || shown.includes(type) || shown.length >= n.max) return;
      if ($('#cart').classList.contains('open')) return;
      const m = messages[type]();
      $('#nudgeIcon').className = m.icon;
      $('#nudgeTitle').textContent = m.title;
      $('#nudgeText').innerHTML = m.text;
      orderPop.hideNow();
      $('#cartNudge').classList.add('show');
      shown.push(type);
      saveShown();
    }
    const hide = () => $('#cartNudge').classList.remove('show');
    const schedule = (type, delay) => { clearTimeout(timer); timer = setTimeout(() => show(type), delay); };

    $('#nudgeCta').addEventListener('click', (e) => { hide(); goToCheckout(e.currentTarget, 'Completa l\'ordine'); });
    $('#nudgeCart').addEventListener('click', () => { hide(); openCart(); });
    $('#nudgeClose').addEventListener('click', hide);

    if (n.exit) {
      document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0) show('exit'); });
    }

    return {
      onAdd() { hide(); schedule('notOpened', n.notOpened); },
      onCartOpen() { hide(); clearTimeout(timer); },
      onCartClose() { if (cart.items.length) schedule('abandoned', n.abandoned); },
      onPurchase() { purchased = true; hide(); clearTimeout(timer); },
      onReturn() { if (cart.items.length) schedule('returning', n.returning); }
    };
  })();

  // ===== AVVIO =====
  $('#closeCart').addEventListener('click', closeCart);
  $('#overlay').addEventListener('click', closeCart);
  $('#checkoutBtn').addEventListener('click', (e) => goToCheckout(e.currentTarget, 'Procedi al checkout'));
  window.addEventListener('hashchange', syncProductWithHash);
  document.addEventListener('click', (e) => { if (e.target.closest('#ppBack')) closeProduct(); });

  renderCart();
  initNav();
  initFaq();
  initRotate();
  initCarousel();
  initReveal();
  initCartPage();
  syncProductWithHash();

  // Popup solo dopo la scelta sui cookie, così non si sovrappongono al banner
  const startPopups = () => { orderPop.start(); cartMarketing.onReturn(); };
  if (window.NixCookies) window.NixCookies.onDecided(startPopups); else startPopups();

  // Editor del tema Shopify: riattiva gli script quando una sezione viene modificata
  document.addEventListener('shopify:section:load', (e) => {
    initFaq(e.target);
    initRotate(e.target);
    initCarousel(e.target);
    $$('.reveal', e.target).forEach((el) => el.classList.add('visible'));
  });

  // Carrello aggiornato in un'altra scheda
  window.addEventListener('pageshow', (e) => { if (e.persisted) fetchCart(); });
})();
